import { incaAccessor } from '@cancercentrum/inca';
import { atom, useAtom } from 'jotai';
import { useCallback, useRef } from 'react';
const renderHackAtom = atom(Symbol());
export function useErrandInternalInfo(key, defaultValue) {
    // Trigga rerenders av alla komponenter som använder hooken när värdet ändras
    const [, setRenderHackAtomValue] = useAtom(renderHackAtom);
    const forceReRenders = useCallback(()=>setRenderHackAtomValue(Symbol()), [
        setRenderHackAtomValue
    ]);
    const getInternalInfoObj = useCallback(()=>{
        const errand = incaAccessor().errand;
        if (!errand) {
            return null;
        }
        const infoString = errand.internalInformation ?? '{}';
        try {
            // Det sparade är ett JSON-objekt
            return JSON.parse(infoString);
        } catch  {
            // TODO: Inte ett JSON-objekt, hur hantera? Alla bör följa samma standard.
            return null;
        }
    }, []);
    const updateInternalInfo = useCallback((updateFn)=>{
        const errand = incaAccessor().errand;
        if (!errand) {
            return;
        }
        const currentInternalInfo = getInternalInfoObj() ?? {};
        currentInternalInfo[key] = updateFn(currentInternalInfo[key]);
        errand.internalInformation = JSON.stringify(currentInternalInfo);
        forceReRenders();
    }, [
        forceReRenders,
        getInternalInfoObj,
        key
    ]);
    const deleteKeyFromInternalInfo = useCallback(()=>{
        const currentInternalInfo = getInternalInfoObj() ?? {};
        if (Object.prototype.hasOwnProperty.call(currentInternalInfo, key)) {
            delete currentInternalInfo[key];
            incaAccessor().errand.internalInformation = JSON.stringify(currentInternalInfo);
            forceReRenders();
        }
    }, [
        forceReRenders,
        getInternalInfoObj,
        key
    ]);
    const defaultValueRef = useRef(defaultValue);
    defaultValueRef.current = defaultValue;
    const getInternalInfo = useCallback(()=>{
        const internalInfoObj = getInternalInfoObj();
        return internalInfoObj?.[key] ?? defaultValueRef.current;
    }, [
        getInternalInfoObj,
        key
    ]);
    return [
        getInternalInfo,
        updateInternalInfo,
        deleteKeyFromInternalInfo
    ];
}
